import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useLocation, useParams } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ProjectDesc from "../../components/ProjectsItem/ProjectDesc";
import SiteDetails from "../../components/ProjectsItem/SiteDetails";
import AssetDetailsTable from "../../components/Tables/AssetDetailsTable";
import StakeHolderDetailsTable from "../../components/Tables/StakeHolderDetailsTable";
import ActivityTable from "../../components/Tables/ActivityTable";
import StatusStepper from "../../components/steppers/StatusStepper";
import {
  getSiteById,
  getStatusById,
} from "../../services/siteServices/subSiteService";
import CommercialsDetailsTable from "../../components/Tables/CommercialsDetailsTable";
import VerticalTabs from "../../components/Tabs/VerticalTabs";
import { getStatusStepper } from "../../services/StatusStepperService.js/StatusStepperService";
import AppConfig from "../../config";
import { Box, Button } from "@mui/material";
import AttachmentTable from "../../components/Tables/AttachmentTable";
import Footer from "../../components/Footer/Footer";

export default function ProjectItems() {
  const { id } = useParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [statusSteps, setStatusSteps] = useState([]);
  const [activeStepnew, setActiveStepnew] = useState(0);
  const [mainStatus, setMainStatus] = useState("");
  const [subStatus, setSubStatus] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [activities, setActivities] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [projectCode, setProjectCode] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [steps, setSteps] = useState(AppConfig.tabsSteps);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [partner, setPartner] = useState("");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    get_Site(id);
  }, [trigger]);

  const get_Site = async (url) => {
    try {
      setIsLoading(true);
      const res2 = await getSiteById(url);
      const projectCode = res2.ProjectDetails?.project_code || "";
      const partnerId = res2.ProjectDetails.partnerId || "";
      setPartner(partnerId);
      setProjectId(res2.ProjectDetails.partnerId || "");
      const projectStatus = res2.ProjectDetails?.project_status || "Draft";
      const subStatus = projectStatus.split("-").pop() || "Draft";
      const mainStatus = projectStatus;
      setSubStatus(subStatus);
      setMainStatus(mainStatus);
      setProjectCode(projectCode);
      let activeStepNew = 1;
      let steps = [];
      const stepperResponse = await getStatusStepper(url, partnerId);
      if (!stepperResponse.length) {
        let subStage = {
          id: 1,
          title: "Data Entry",
          isTitle: true,
          active: true,
          isMainStageCompleted: false,
        };
        steps.push(subStage);
        setStatusSteps(steps);
        return;
      } else {
        let subStage = {
          id: 1,
          title: "Data Entry",
          isTitle: true,
          active: true,
          isMainStageCompleted: true,
        };
        steps.push(subStage);
        for (let i = 0; i < stepperResponse.length; i++) {
          const stage = stepperResponse[i];
          let subStageLen = stage.activities.length;
          const doneActivities = stage.activities.filter(
            (activity) => activity.Status === "Done"
          );
          const step = {
            id: i + 1,
            title: stage.StageName,
            isTitle: true,
            active: stage.Status === "Done",
            isMainStageCompleted: subStageLen === doneActivities.length,
          };
          if (stage.Status !== "Done" && stage.Status !== "Not Started") {
            activeStepNew++;
          } else if (stage.Status === "Done") {
            activeStepNew++;
          }
          steps.push(step);

          if (stage.Status !== "Done" && stage.Status !== "Not Started") {
            for (let j = 0; j < stage.activities.length; j++) {
              const activity = stage.activities[j];
              let subStep = {
                id: j + 1,
                title: activity.ActivityName,
                isTitle: false,
                active: activity.Status === "Done",
                isMainStageCompleted: activity.Status === "Done",
              };

              if (activity.Status === "Done") {
                activeStepNew++;
              }
              steps.push(subStep);
            }
          }
        }
      }
      setStatusSteps(steps);
      setActiveStepnew(activeStepNew);
    } catch (e) {
      // Handle error
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "draft":
        return { color: "#FF0000", background: "#FFCCCC" };
      case "done":
        return { color: "#008000", background: "#CCFFCC" };
      case "in progress":
        return { color: "#FFA500", background: "#FFE5B4" };
      case "started":
        return { color: "#000", background: "#ddd" };
      default:
        return { color: "#000", background: "#fff" };
    }
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <ProjectDesc />;
      case 1:
        return <SiteDetails />;
      case 2:
        return <StakeHolderDetailsTable projectCode={projectCode} />;
      case 3:
        return <AssetDetailsTable />;
      case 4:
        return <CommercialsDetailsTable />;
      case 5:
        return <AttachmentTable projectCode={projectCode} />;
      case 6:
        return (
          <ActivityTable
            activities={activities}
            setActivities={setActivities}
            setSteps={setSteps}
            get_Site={get_Site}
            setTrigger={setTrigger}
            trigger={trigger}
            projectCode={projectCode}
            projectId={projectId}
            partner={partner}
          />
        );
      default:
        throw new Error("Unknown step");
    }
  }

  const handleActiveStepByClick = (event, newValue) => {
    setActiveStep(newValue);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Box>
      <Grid container spacing={2} sx={{ backgroundColor: "#fff" }}>
        <Grid item xs={12}>
          <Grid
            container
            alignItems="center"
            sx={{
              padding: "20px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#fff",
            }}
          >
            <Grid item>
              <Typography sx={{ fontSize: "24px", fontWeight: 600 }}>
                Sites
              </Typography>
            </Grid>
            <Grid item sx={{ marginLeft: "10px" }}>
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 400,
                  color: "#555",
                }}
              >
                / {projectCode ? projectCode : location?.state?.lookUpId}
              </Typography>
            </Grid>
            <Grid item sx={{ marginLeft: "10px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: getStatusColor(subStatus).color,
                  backgroundColor: getStatusColor(subStatus).background,
                  borderRadius: "5px",
                  padding: "4px 8px",
                }}
              >
                {mainStatus}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid
            container
            sx={{
              width: "100%",
              py: 2,
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#fff",
            }}
          >
            <StatusStepper steps={statusSteps} activeStepnew={activeStepnew} />
          </Grid>
        </Grid>

        <Grid item xs={12} md={2}>
          <VerticalTabs
            steps={steps}
            selectedTab={activeStep}
            handleTabChange={handleActiveStepByClick}
          />
        </Grid>

        <Grid item xs={12} md={10}>
          <Grid
            container
            direction="column"
            sx={{
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#fff",
              height: "100%",
              overflowY: "auto",
            }}
          >
            {isLoading ? (
              <Typography variant="h6">Loading...</Typography>
            ) : (
              getStepContent(activeStep)
            )}
          </Grid>
        </Grid>

        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>{"Confirm Action"}</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to perform this action?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            <Button onClick={handleCloseModal} autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
      {/* <Footer /> */}
    </Box>
  );
}
